import { boolean, object, string } from "superstruct";

export const RewardsSpendingRulesRefundSchema = object({
    rewardId: string(),
    discountCode: string(),
    success: boolean(),
});
